import { RouteConstants } from "./route-constant";

/** True when the current path belongs to the UM module shell. */
export const isUmPath = (pathname: string) =>
  pathname.startsWith(RouteConstants.ROUTE_UM_MODULE);

export const getMessagesListRoute = (pathname: string) =>
  isUmPath(pathname)
    ? RouteConstants.ROUTE_UM_MESSAGES
    : RouteConstants.ROUTE_MESSAGES;

export const getMessageDetailsRoute = (
  pathname: string,
  conversationId: string
) => {
  const template = isUmPath(pathname)
    ? RouteConstants.ROUTE_UM_MESSAGE_DETAILS
    : RouteConstants.ROUTE_MESSAGE_DETAILS;
  return template.replace(":conversation_id", conversationId);
};
